import type { CreateCheckoutSessionInput } from '@affine/graphql';
import { mixpanel } from '@affine/track';
import { OnEvent, Service } from '@toeverything/infra';

import { Subscription } from '../entities/subscription';
import { SubscriptionPrices } from '../entities/subscription-prices';
import { AccountChanged } from '../events/account-changed';
import type { SubscriptionStore } from '../stores/subscription';

@OnEvent(AccountChanged, e => e.onAccountChanged)
export class SubscriptionService extends Service {
  subscription = this.framework.createEntity(Subscription);
  prices = this.framework.createEntity(SubscriptionPrices);

  constructor(private readonly store: SubscriptionStore) {
    super();
    this.subscription.ai$
      .map(sub => !!sub)
      .distinctUntilChanged()
      .subscribe(ai => {
        mixpanel.people.set({
          ai,
        });
      });
    this.subscription.pro$
      .map(sub => !!sub)
      .distinctUntilChanged()
      .subscribe(pro => {
        mixpanel.people.set({
          pro,
        });
      });
    this.subscription.studio$
      .map(sub => !!sub)
      .distinctUntilChanged()
      .subscribe(studio => {
        mixpanel.people.set({
          studio,
        });
      });
  }

  async createCheckoutSession(input: CreateCheckoutSessionInput) {
    const res = await this.store.createCheckoutSession(input);
    return res;
  }
  async getSubscribeModalData(locale: string) {
    return await this.store.getSubscribeModalData(locale);
  }

  private onAccountChanged() {
    this.subscription.revalidate();
  }
}
